import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  products: [],
  isLoading: true,
  isSuccess: false,
  isError: false,
  getProductStatus: "",
  getProductError: "",
  message: "",
  response: {},
  imageUrl: "",
};

export const getProducts = createAsyncThunk(
  "products/getProducts",
  async (page = 0, thunkAPI) => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_KEY}/product/getproduct?page=${page}&size=10`
    );
    return response.data;
  }
);
export const getSearchProducts = createAsyncThunk(
  "products/getSearchProducts",
  async (searchTerm, { rejectWithValue }) => {
    console.log("search", searchTerm);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/product/get_search_products`,
        { search: searchTerm }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

const productSlice = createSlice({
  name: "products",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getProducts.pending, (state) => {
      state.isLoading = true;
      state.getProductStatus = "pending";
      state.getProductError = "";
    });
    builder.addCase(getProducts.fulfilled, (state, action) => {
      state.isLoading = false;
      state.products = action.payload.result;
      state.response = action.payload;
      state.imageUrl = action.payload.image_url;
      state.getProductStatus = "success";
      state.getProductError = "";
    });
    builder.addCase(getProducts.rejected, (state, action) => {
      state.isLoading = false;
      state.getProductStatus = "rejected";
      state.getProductError = action.payload;
      console.error(action.payload.response.data);
    });

    builder.addCase(getSearchProducts.pending, (state) => {
      state.isLoading = true;
      state.getProductStatus = "pending";
      state.getProductError = "";
    });
    builder.addCase(getSearchProducts.fulfilled, (state, action) => {
      state.isLoading = false;
      state.products = action.payload.data;
      console.log("searchData", action.payload);
      state.response = action.payload;
      state.getProductStatus = "success";
      state.getProductError = "";
    });
    builder.addCase(getSearchProducts.rejected, (state, action) => {
      state.isLoading = false;
      state.getProductStatus = "rejected";
      state.getProductError = action.payload;
      console.error(action.payload.response.data);
    });
  },
});

export default productSlice.reducer;
